export default class Bridge
{
    onRouteBack() { }
    onData(data){}

    routeBack()
    {
        this.onRouteBack();
    }
    sendData(data)
    {
        return this.onData(data);
    }
}



// WEBPACK FOOTER //
// ./src/router/bridge.js